import * as React from "react";
import { FormattedNumber, FormattedMessage } from "react-intl";

type Props = {
    price: number | null | undefined;
    currency: string | null | undefined;
    isWeightArticle: boolean | undefined;
    unitIndicatorWeight?: string | undefined;
    messageTranslationKey: string | null | undefined;
    className: string;
};

function MoneyAmount({
    price,
    currency,
    isWeightArticle,
    unitIndicatorWeight,
    messageTranslationKey,
    className
}: Props) {
    if (!price || !currency || currency === "XXX") {
        return (
            <span className={"no-amount " + className}>
                <FormattedMessage id="NOT_AVAILABLE_ABBREVIATION" />
            </span>
        );
    }

    // JPY currency needs 0 decimal places instead of 2
    const format = currency === "JPY" ? "currencyJPY" : "currency";
    const priceMessage = <FormattedNumber value={price} format={format} currency={currency} />;
    const unitIndicatorKey = isWeightArticle && unitIndicatorWeight ? unitIndicatorWeight : "";
    const unitIndicatorMessage = unitIndicatorKey !== "" ? <FormattedMessage id={unitIndicatorKey} /> : null;
    const perUnit = unitIndicatorMessage ? <span> / {unitIndicatorMessage}</span> : null;

    if (messageTranslationKey && messageTranslationKey !== "") {
        return (
            <span className={className}>
                <FormattedMessage id={messageTranslationKey} values={{ price: priceMessage, perUnit: perUnit }} />
            </span>
        );
    } else {
        return (
            <span className={className}>
                {priceMessage}
                {perUnit}
            </span>
        );
    }
}

export default MoneyAmount;
